import RadioButton from '@ben/orion/radio-button';
import Typography, { TypographyVariant } from '@ben/orion/typography';
import styled, { css } from 'styled-components';

interface MinMaxConfigurationProps {
  isFixedNumber: boolean;
  setIsFixedNumber: (value: boolean) => void;
}

const MinMaxConfiguration = ({
  isFixedNumber,
  setIsFixedNumber,
}: MinMaxConfigurationProps) => {
  return (
    <Wrapper>
      <Typography variant={TypographyVariant.bodyMd2}>
        Minimum / maximum configuration
      </Typography>
      <OptionContainer>
        <RadioButton
          label="Fixed number"
          value="minimum"
          checked={isFixedNumber}
          onChange={() => setIsFixedNumber(true)}
        />
        <RadioButton
          label="Calculated value formula"
          value="maximum"
          checked={!isFixedNumber}
          onChange={() => setIsFixedNumber(false)}
        />
      </OptionContainer>
    </Wrapper>
  );
};

export default MinMaxConfiguration;

const Wrapper = styled.div`
  ${({ theme }) => css`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(2)};
  `}
`;

const OptionContainer = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: row;
    gap: ${theme.spacing(2)};
  `}
`;
